/** Short label for a category or count. Tones: neutral, brand, success, warning, danger, info. */
const Badge = ({ tone = 'neutral', mono = false, children }) => {
  const classes = ['comp-badge', `comp-badge--${tone}`];
  if (mono) {
    classes.push('comp-badge--mono');
  }
  return <span className={classes.join(' ')}>{children}</span>;
};

export default Badge;
